import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Rate } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import NoImage from "../../../images/no-image.jpg"; // replace with your placeholder image
import { useNavigate, useParams } from "react-router-dom";
import { getCountries } from "../../../services/CountryService";
import Swal from "sweetalert2";
import PageTitle from "../../layouts/PageTitle";
import { Button } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomClassicEditor from "../CustomClassicEditor";

const EditorPage = () => {
    const [desc, setDesc] = useState("");
    const navigate = useNavigate();

    return (
        <>
            <PageTitle
                activeMenu={`Editor Page`}
                motherMenu="Editor Page"
                activeMenuLink={`editor-page`}
                motherMenuLink={"editor-page"}
            />
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12 col-xxl-12">
                            <div className="card h-auto">
                                <div className="card-body">
                                    <div className="mb-3 editor-container">
                                        <label className="form-label">Content</label>
                                        <CKEditor
                                            editor={CustomClassicEditor}
                                            data={(desc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                            onChange={(event, editor) => {
                                                setDesc(editor.getData());
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditorPage;
